module.exports = __webpack_public_path__ + "img/img_xinshou_12.cd1e82a3.png";